import React from "react";
import { Select } from "antd";

const { Option } = Select;

function MultiSelectFilter({
  label,
  field,
  placeholder,
  options = [],
  value = [],
  onChange,
  loading,
}) {
  const hasOptions = Array.isArray(options) && options.length > 0;
  const hasValue = Array.isArray(value) && value.length > 0;

  const computedPlaceholder = loading
    ? "Cargando..."
    : !hasOptions || (!hasValue && !hasOptions)
    ? `No existe ${placeholder.toLowerCase()} para consultar`
    : `Seleccione ${placeholder.toLowerCase()} (uno o varios)`;

  return (
    <div style={{ marginBottom: 16 }}>
      <label>{label}</label>
      <br />
      <Select
        mode="multiple"
        allowClear
        placeholder={computedPlaceholder}
        value={value}
        onChange={(values) => onChange(field, values)}
        disabled={loading || !hasOptions}
        notFoundContent={loading ? "Cargando..." : "Sin opciones"}
        style={{ width: "100%" }}
        onInputKeyDown={(e) => e.preventDefault()}
        onSearch={() => false}
      >
        {!loading &&
          hasOptions &&
          options.map((opt) => (
            <Option key={opt.key} value={opt.key}>
              {opt.value}
            </Option>
          ))}
      </Select>
    </div>
  );
}

export default MultiSelectFilter;
